import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const SalesReportService = {
  // Define your API functions here
  returnBill: async (data) => {
    const response = await apiService.post("/returnbilllogs", data);
    return response.data;
  },
  returnBillList: async () => {
    const response = await apiService.get("/returnbilllogs");
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/billinglogs/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async ({
    pageNumber = 1,
    perPage = 10,
    BillDateFrom = "",
    BillDateTo = "",
  }) => {
    const params = new URLSearchParams({
      ...(BillDateFrom && { BillDateFrom }),
      ...(BillDateTo && { BillDateTo }),
      Page: pageNumber.toString(),
      PageSize: perPage.toString(),
    });
    const response = await apiService.get(`/billinglogs?${params.toString()}`);
    return response.data;
  },

  getDetail: async (orderRefNumber) => {
    const response = await apiService.get(`/order/refnumber/${orderRefNumber}`);
    return response.data;
  },
  getCustomerBooking: async (id) => {
    const response = await apiService.get(`/customers/${id}/bookings`);
    return response.data;
  },

  guestUserList: async () => {
    const response = await apiService.get("/guestusers");
    return response.data;
  },
  getGuestDetail: async (id) => {
    const response = await apiService.get(
      `/billinglogs/guest/withorderdetail/${id}`
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/billinglogs/${id}`);
    return response.data;
  },

  categoryWise: async ({ categoryName, fromDate, toDate }) => {
    const params = new URLSearchParams();
    if (categoryName) params.append("categoryName", categoryName);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);

    const response = await apiService.get(
      `/salesreport/category-wise?${params.toString()}`
    );

    return response.data;
  },
  itemWise: async ({ itemName, categoryId, fromDate, toDate }) => {
    const params = new URLSearchParams();
    if (itemName) params.append("itemName", itemName);
    if (categoryId) params.append("categoryId", categoryId);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);

    const response = await apiService.get(
      `/salesreport/item-wise?${params.toString()}`
    );

    return response.data;
  },
  itemPercent: async ({ categoryId, fromDate, toDate }) => {
    const params = new URLSearchParams();
    if (categoryId) params.append("categoryId", categoryId);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);

    const response = await apiService.get(
      `/salesreport/item-sales-percentage?${params.toString()}`
    );

    return response.data;
  },

  //transaction report
  getTransactionList: async ({
    productId,
    productName,
    fromDate,
    toDate,
    page = 1,
    pageSize = 10,
  }) => {
    const params = new URLSearchParams();

    if (productId) params.append("ProductId", productId);
    if (productName) params.append("ProductName", productName);
    if (fromDate) params.append("FromDate", fromDate);
    if (toDate) params.append("ToDate", toDate);

    params.append("Page", page);
    params.append("PageSize", pageSize);

    const response = await apiService.get(
      `/producttransactionlogreport/transactions?${params.toString()}`
    );

    return response.data;
  },

  getTransactionExportList: async ({
    productId,
    productName,
    fromDate,
    toDate,
    page = 1,
    pageSize = 10000,
  }) => {
    const params = new URLSearchParams();

    if (productId) params.append("ProductId", productId);
    if (productName) params.append("ProductName", productName);
    if (fromDate) params.append("FromDate", fromDate);
    if (toDate) params.append("ToDate", toDate);

    params.append("Page", page);
    params.append("PageSize", pageSize);

    const response = await apiService.get(
      `/producttransactionlogreport/transactions?${params.toString()}`
    );

    return response.data;
  },
};

export default SalesReportService;
